export const studentListData = [
  {
    Key: "1",
    Img:"user-01.jpg",
    StudentID: "#STU020",
    StudentName: "Thompson Hicks",
    EnrollDate: "22 Aug 2025",
    Progress: "0%",
    Courses: 10,
  },
  {
    Key: "2",
    Img:"user-06.jpg",
    StudentID: "#STU019",
    StudentName: "Jennifer Tovar",
    EnrollDate: "10 Aug 2025",
    Progress: "15%",
    Courses: 8,
  },
  {
    Key: "3",
    Img:"user-09.jpg",
    StudentID: "#STU018",
    StudentName: "James Schulte",
    EnrollDate: "26 Jul 2025",
    Progress: "60%",
    Courses: 12,
  },
  {
    Key: "4",
    Img:"user-20.jpg",
    StudentID: "#STU017",
    StudentName: "Kristy Cardona",
    EnrollDate: "12 Jul 2025",
    Progress: "20%",
    Courses: 17,
  },
  {
    Key: "5",
    Img:"user-27.jpg",
    StudentID: "#STU016",
    StudentName: "William Aragon",
    EnrollDate: "02 Jul 2025",
    Progress: "10%",
    Courses: 9,
  },
  {
    Key: "6",
    Img:"user-30.jpg",
    StudentID: "#STU015",
    StudentName: "Shirley Lis",
    EnrollDate: "25 Jun 2025",
    Progress: "80%",
    Courses: 15,
  },
  {
    Key: "7",
    Img:"user-17.jpg",
    StudentID: "#STU014",
    StudentName: "John Brewer",
    EnrollDate: "17 Jun 2025",
    Progress: "40%",
    Courses: 13,
  },
  {
    Key: "8",
    Img:"user-37.jpg",
    StudentID: "#STU013",
    StudentName: "Doris Hughes",
    EnrollDate: "04 Jun 2025",
    Progress: "50%",
    Courses: 17,
  },
  {
    Key: "9",
    Img:"user-04.jpg",
    StudentID: "#STU012",
    StudentName: "Sarah Martinez",
    EnrollDate: "20 May 2025",
    Progress: "20%",
    Courses: 8,
  },
  {
    Key: "10",
    Img:"user-18.jpg",
    StudentID: "#STU011",
    StudentName: "Sarah Martinez",
    EnrollDate: "15 May 2025",
    Progress: "60%",
    Courses: 10,
  },
];
